import React from 'react';

import { AgencyDetailsPage } from '@components/admin/agency/AgencyDetailsPage';
import { useUser } from '@hooks/queries/useUser';

export const AgencyDetails: React.FC = () => {
  const user = useUser();

  return (
    <AgencyDetailsPage
      agencyId={user.data?.agency_id ?? undefined}
      isAdmin={false}
      isLoading={user.isLoading}
    />
  );
};
